import { useQuery } from "@tanstack/react-query";
import { fetchSettings } from "../api/settings";

export default function useSettingsQuery() {
    return useQuery({
        queryKey: ["wahchan", "settings"],
        queryFn: ({ signal }) => fetchSettings({ signal }),
        staleTime: Infinity,
        gcTime: Infinity,
        refetchOnWindowFocus: false,
    });
}
